import React from 'react';
import Collapsible from '../../../components/Collapsible/Collapsible';
import DarkWeb from '../DarkWeb/DarkWeb';
import { Message } from './MonitoringStyles';
import { SERVICES } from '../../../Landing/LandingConstants';
import { DARK_WEB_MESSAGE } from '../DarkWeb/DarkWebConstants';

const Monitoring = () => (
  <div>
    {SERVICES.slice(1).map(({ id, title, message }) => (
      <Collapsible key={id} title={title}>
        <Message>{message}</Message>
      </Collapsible>
    ))}
    <Collapsible title="Dark Web Monitoring">
      <Message>{DARK_WEB_MESSAGE}</Message>
      <DarkWeb />
    </Collapsible>
  </div>
);

export default Monitoring;
